<template>
    <div>
        <Search v-model="searchInput" placeholder="搜索"/>
        <div style="overflow-x: hidden;height: calc(100vh - 105px);overflow-y: auto">
            <ul v-for="(model, index) in unitTree" :key="index">
                <TreeMenu :model="model" :key="searchInput.length>0" @item="onSelect" :searchText="searchInput" :depth="searchInput.length>0?9:undefined"/>
            </ul>
        </div>
    </div>
</template>

<script>
    import {Collapse, CollapseItem, Search} from 'vant'
    import TreeMenu from "@/components/TreeMenu";

    export default {
        components: {Collapse, CollapseItem, TreeMenu, Search},
        mounted() {
            this.loadUnitTree()
        },
        data() {
            return {unitTree: [], searchInput: ''}
        },
        computed: {},
        methods: {
            loadUnitTree() {
                this.$http.tokiot.sys.unit.v2.tree({})
                    .then(ret => {
                        this.unitTree = [ret]
                    })
            },
            onSelect(data) {
                this.$emit('onSelect', data)
            }
        }
    }
</script>

<style scoped>

</style>